import React, { useState } from 'react';
import SatisfactionGuaranteeModal from './SatisfactionGuaranteeModal';

export default function TrustBar({ variant = 'default' }) {
  const [isGuaranteeOpen, setIsGuaranteeOpen] = useState(false);

  const items = [
    {
      icon: 'fa-light fa-award',
      label: '12 års erfaring',
      sub: 'Egen praksis siden 2014',
    },
    {
      icon: 'fa-light fa-users',
      label: '500+ klienter hjulpet',
      sub: 'Individuelle forløb & grupper',
    },
    {
      icon: 'fa-light fa-shield-check',
      label: '100% tilfredshedsgaranti',
      sub: 'Trygge vilkår ved 1. session',
      action: () => setIsGuaranteeOpen(true),
    },
    {
      icon: 'fa-light fa-comments',
      label: 'Gratis afklaringssamtale',
      sub: '20 min. uforpligtende samtale',
    },
  ];

  if (variant === 'compact') {
    return (
      <>
        <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-6 gap-y-2 text-xs text-[#6c7480]">
          <span className="inline-flex items-center gap-1.5 font-medium text-[#5A232E]">
            <i className="fa-solid fa-badge-check text-[#5A232E]" aria-hidden="true" />
            12 års erfaring
          </span>
          <span className="hidden sm:inline text-[#D8D0C5]">•</span>
          <span className="inline-flex items-center gap-1.5 font-medium text-[#5A232E]">
            <i className="fa-solid fa-users text-[#5A232E]" aria-hidden="true" />
            500+ klienter hjulpet
          </span>
          <span className="hidden sm:inline text-[#D8D0C5]">•</span>
          <button
            type="button"
            onClick={() => setIsGuaranteeOpen(true)}
            className="inline-flex items-center gap-1.5 font-medium text-[#5A232E] hover:text-[#5A232E] underline decoration-dotted transition-colors"
          >
            <i className="fa-solid fa-shield-check text-[#5A232E]" aria-hidden="true" />
            100% tilfredshedsgaranti
          </button>
          <span className="hidden sm:inline text-[#D8D0C5]">•</span>
          <span className="inline-flex items-center gap-1.5 font-medium text-[#5A232E]">
            <i className="fa-solid fa-comments text-[#5A232E]" aria-hidden="true" />
            Gratis afklaringssamtale (20 min.)
          </span>
        </div>

        <SatisfactionGuaranteeModal
          isOpen={isGuaranteeOpen}
          onClose={() => setIsGuaranteeOpen(false)}
        />
      </>
    );
  }

  return (
    <>
      <section className="bg-[#ECEEF1] border-y border-[#D9DDE2] py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-10 sm:gap-y-12 lg:gap-y-0">
            {items.map((item, idx) => (
              <div
                key={idx}
                className="relative flex flex-col items-center text-center px-4 sm:px-6 lg:px-8"
              >
                {/* Thin vertical divider between columns on desktop (starts around upper area, ends before bottom) */}
                {idx > 0 && (
                  <div
                    className="hidden lg:block absolute left-0 top-3 bottom-3 w-px bg-[#D9DDE2]"
                    aria-hidden="true"
                  />
                )}

                {/* Subtle horizontal separator between items on mobile */}
                {idx > 0 && (
                  <div
                    className="block sm:hidden absolute -top-5 left-1/4 right-1/4 h-px bg-[#D9DDE2]/70"
                    aria-hidden="true"
                  />
                )}

                {/* Minimal outline icon directly on background */}
                <div className="mb-4 text-[#5A232E]">
                  <i className={`${item.icon} text-3xl sm:text-4xl`} aria-hidden="true" />
                </div>

                {/* Heading / Title */}
                {item.action ? (
                  <button
                    type="button"
                    onClick={item.action}
                    className="font-display font-medium text-base sm:text-lg text-[#11161d] hover:text-[#5A232E] transition-colors cursor-pointer inline-flex items-center gap-1.5 focus:outline-hidden"
                  >
                    <span>{item.label}</span>
                    <i className="fa-regular fa-circle-question text-xs text-[#6c7480]" aria-hidden="true" />
                  </button>
                ) : (
                  <h3 className="font-display font-medium text-base sm:text-lg text-[#11161d]">
                    {item.label}
                  </h3>
                )}

                {/* Short descriptive text */}
                <p className="mt-2 text-xs sm:text-sm text-[#6c7480] leading-relaxed max-w-[240px]">
                  {item.sub}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SatisfactionGuaranteeModal
        isOpen={isGuaranteeOpen}
        onClose={() => setIsGuaranteeOpen(false)}
      />
    </>
  );
}
